import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";

// Prefetch: el panel se descarga en segundo plano mientras se ve la página
// pública o el login — el admin deja de cargar en cascada.
const Login = lazy(() => import(/* webpackPrefetch: true */ "@/pages/admin/Login"));
const AdminLayout = lazy(() => import(/* webpackPrefetch: true */ "@/pages/admin/AdminLayout"));
const Dashboard = lazy(() => import(/* webpackPrefetch: true */ "@/pages/admin/Dashboard"));
const Brand = lazy(() => import("@/pages/admin/Brand"));
const HeroManager = lazy(() => import("@/pages/admin/HeroManager"));
const PageEditor = lazy(() => import("@/pages/admin/PageEditor"));
const Projects = lazy(() => import("@/pages/admin/Projects"));
const Services = lazy(() => import("@/pages/admin/Services"));
const Quotes = lazy(() => import("@/pages/admin/Quotes"));
const QrPage = lazy(() => import("@/pages/admin/QrPage"));
const Settings = lazy(() => import("@/pages/admin/Settings"));

const host = window.location.hostname;
// www.teravix.net → página comercial pública en la raíz.
// teravix.net (apex), admin.* y el enlace de Emergent → acceso al panel.
// /sitio siempre muestra la página pública (alias seguro en cualquier host).
const isPublicHost = host.startsWith("www.");

const publicSite = <SiteProvider><Landing /></SiteProvider>;

const loader = (
  <div className="min-h-screen bg-[#030305] flex items-center justify-center">
    <div className="w-10 h-10 rounded-full border-2 border-[#0A84FF] border-t-transparent animate-spin" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-center" richColors />
        <Suspense fallback={loader}>
          <Routes>
            <Route path="/" element={isPublicHost ? publicSite : <Navigate to="/admin" replace />} />
            <Route path="/sitio" element={publicSite} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="marca" element={<Brand />} />
              <Route path="portada" element={<HeroManager />} />
              <Route path="pagina" element={<PageEditor />} />
              <Route path="proyectos" element={<Projects />} />
              <Route path="servicios" element={<Services />} />
              <Route path="solicitudes" element={<Quotes />} />
              <Route path="qr" element={<QrPage />} />
              <Route path="configuracion" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to={isPublicHost ? "/" : "/admin"} replace />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
